import * as CalculatorStepTracker from "@omni/services/tracking/trackers/tools/calculators/calculatorStep.tracker";
import { CALCULATOR_KEYS } from "@omni/services/tracking/trackers/tools/calculators/config";
import { parseFloatSafe } from "@omni/utils/number.utils";
import queryString from "query-string";
import { useEffect, useState } from "react";

import Calculation from "./calculation/calculation.component";
import Result from "./result/result.component";

const CementscreedCalculator = () => {
    const q = queryString.parse(location.search, {
        parseNumbers: true
    });

    const [cementscreedLength, setCementscreedLength] = useState<string>(
        q.cementscreedLength?.toString() || "0"
    );

    const [cementscreedWidth, setCementscreedWidth] = useState<string>(
        q.cementscreedWidth?.toString() || "0"
    );

    const [cementscreedThickness, setCementscreedThickness] = useState<string>(
        q.cementscreedThickness?.toString() || "0"
    );

    const [cementscreedArea, setCementscreedArea] = useState(0);
    const [cementscreedVolume, setCementscreedVolume] = useState(0);

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        setCementscreedArea(determineCementscreedArea());
        setCementscreedVolume(determineCementscreedVolume());
        CalculatorStepTracker.trackStart(CALCULATOR_KEYS.cementScreed);
    }, []);

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        setCementscreedArea(determineCementscreedArea());
        setCementscreedVolume(determineCementscreedVolume());
    }, [cementscreedLength, cementscreedWidth, cementscreedThickness]);

    const determineCementscreedArea = () => {
        const length = parseFloatSafe(cementscreedLength, 0);

        const width = parseFloatSafe(cementscreedWidth, 0);
        const area = length * width;

        return area;
    };

    const determineCementscreedVolume = () => {
        const length = parseFloatSafe(cementscreedLength, 0);

        const width = parseFloatSafe(cementscreedWidth, 0);

        const height = parseFloatSafe(cementscreedThickness, 0) * 0.01; // convert cm to m
        const volume = length * width * height;

        return volume;
    };

    const setCalculationValue = (field: string, value: string) => {
        switch (field) {
            case "cementscreedLength": {
                setCementscreedLength(value);
                break;
            }
            case "cementscreedWidth": {
                setCementscreedWidth(value);
                break;
            }
            case "cementscreedThickness": {
                setCementscreedThickness(value);
                break;
            }
        }

        CalculatorStepTracker.trackSubmit(CALCULATOR_KEYS.cementScreed);
    };

    const calculationProps = {
        setCalculationValue: setCalculationValue,
        cementscreedLength: cementscreedLength,
        cementscreedWidth: cementscreedWidth,
        cementscreedThickness: cementscreedThickness
    };
    const resultProps = {
        cementscreedArea: cementscreedArea,
        cementscreedVolume: cementscreedVolume,
        mailParams: {
            cementscreedLength: cementscreedLength,
            cementscreedWidth: cementscreedWidth,
            cementscreedThickness: cementscreedThickness
        }
    };

    return (
        <div id="calculator">
            <Calculation {...calculationProps} />
            <Result {...resultProps} />
        </div>
    );
};

export { CementscreedCalculator };
